import React, { useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import axios from 'axios';
import presignS3 from '../../../utils/s3Presign';
import { PropTypes } from 'prop-types';
import addEditMamObject from '../../../api/graphql/mutations/addEditMamObject';
import MamObjectForm from './MamObjectForm';
import Modal from '../../Modal/Modal';
import checkFileType from '../../../utils/checkFileType';


const Uploader = ({ multiple, handleMoreItems }) => {
  const initialState = {
    assetSlugName: '',
    filename: '',
    fileExtension: '',
    url: '',
    fileReadableName: {
      en: '',
      es: '',
      ca: '',
      pt: '',
    },
    description: {
      en: '',
      es: '',
      ca: '',
      pt: '',
    },
    type: '',
    tags: [],
    isPublic: false,
  };

  const uploaderCopy = {
    single: 'Drop a file here, or click to select a file',
    multiple: 'Drop some files here, or click to select files',
  };

  const [uploading, setUploading] = useState(false);
  const [state, setState] = useState(initialState);
  const [showForm, setShowForm] = useState(false);

  const inputObjHandler = (e) => {
    const { value, lang, name } = e.target;
    const data = {
      ...state,
      [name]: {
        ...state[name],
        [lang]: value,
      },
    };
    setState(data);
  };

  const makePublicHandler = (bool) => {
    const data = {
      ...state,
      isPublic: bool,
    };
    setState(data);
  };

  const saveObjectBeforeClse = obj => addEditMamObject(obj)
    .catch(err => console.log(err));

  const onDrop = useCallback((files) => {
    // route where file will be uploaded, the route will be the same fot all files
    files.forEach((file) => {
      // generate a random name for the file
      // eslint-disable-next-line no-bitwise
      const randomFileName = [...Array(20)].map(() => (~~(Math.random() * 36)).toString(36)).join('');
      const fileExtension = file.name.split('.').pop();
      const filename = `${randomFileName}_${Date.now().toString()}`;
      const filenameWithExtension = `${filename}.${fileExtension}`;
      const url = `https://assets.primaverasound.com/psweb/${filenameWithExtension}`;

      // if (fileExtension === 'jpeg') return setError('You can only images in .PNG or .JPG formats');

      presignS3({
        fileName: filenameWithExtension,
        fileType: file.type,
        type: 'upload',
      })
        .then(async (result) => {
          const signedUrl = result.data;
          const options = {
            headers: {
              'Content-Type': file.type,
            },
            crossDomain: true,
          };
          setUploading(true);
          await axios.put(signedUrl, file, options);
          setUploading(false);
        })
        .then((res) => {
          // once uploaded to s3, the object is uploaded to the DB
          const assetObject = {
            ...state,
            assetSlugName: filename,
            fileReadableName: {
              en: file.name.substring(0, file.name.lastIndexOf('.')) || file.name,
            },
            filename,
            fileExtension,
            url,
            type: checkFileType(fileExtension),
            fileSize: file.size,
          };
          setState(assetObject);
          setShowForm(true);
          saveObjectBeforeClse(assetObject).then(() => {
            if (handleMoreItems) {
              handleMoreItems([assetObject]);
            }
          });
          // Call form with initial state
        })
        .catch((err) => {
          console.log(err);
        });
    });
  });

  const handleClick = () => {
    setShowForm(!showForm);
  };

  const saveObject = () => {
    addEditMamObject({ ...state })
      .then(() => {
        setShowForm(false);
        setState(initialState);
      })
      .catch(err => console.log(err));
  };

  const handleTags = (name) => {
    const index = state.tags.indexOf(name);
    const { tags } = state;
    if (index < 0) {
      tags.push(name);
    } else {
      tags.splice(index, 1);
    }
    const data = {
      ...state,
      tags,
    };
    setState(data);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, multiple });
  return (
    <>
      {showForm
      && (
      <Modal title="Edit file" handleClick={handleClick} type="display" size="w-auto" close={handleClick}>
        <MamObjectForm objState={state} makePublicHandler={makePublicHandler} inputObjHandler={inputObjHandler} saveObject={saveObject} close={handleClick} toggleTag={handleTags} />
      </Modal>
      )}
      <div {...getRootProps()} className="flex flex-col items-center justify-center border-dashed border-greyFilter border-2 rounded-lg py-8 my-4 outline-none mx-1">
        <input {...getInputProps()} />

        <p className="text-sm font-americaMonoRegular uppercase cursor-default">{multiple ? uploaderCopy.multiple : uploaderCopy.single}</p>
        <span className="font-icon text-greyFilter text-4xl icon-add-image3 py-4" />
        <p className="text-sm font-americaMonoRegular uppercase border-1 border-black rounded-full px-5 py-1 cursor-default mb-4">Browse file</p>

        {uploading && <p className="font-americaMonoRegular uppercase"> Uploading file... </p>}
      </div>
    </>
  );
};

Uploader.propTypes = {
  multiple: PropTypes.bool,
  handleMoreItems: PropTypes.func,
};

Uploader.defaultProps = {
  multiple: false,
  handleMoreItems: null,
};

export default Uploader;
